import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CustomCategoryDetail } from '../types';

interface ReorderCustomFieldsParams {
  categoryId: number;
  fieldOrders: Array<{ id: number; order_number: number }>;
}

/**
 * カスタムフィールドの順序変更用のフック
 */
export default function useReorderCustomFields() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ categoryId, fieldOrders }: ReorderCustomFieldsParams) => {
      const response = await fetch('/agent/api/custom_fields/reorder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          custom_category_id: categoryId,
          field_orders: fieldOrders,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '順序の更新に失敗しました');
      }

      const data = await response.json();
      return { categoryId, customFields: data.records };
    },
    onSuccess: (data) => {
      // サーバーから返された正しい順序でキャッシュを直接更新
      queryClient.setQueryData<CustomCategoryDetail>(
        ['custom_category', data.categoryId],
        (old) => {
          if (!old) return old;
          return {
            ...old,
            custom_fields: data.customFields,
          };
        }
      );
    },
  });
}
